export function blurInteractiveElements() {
  const { activeElement } = document;

  if (
    activeElement
    && activeElement !== document.body
    && ['BUTTON', 'A', 'INPUT', 'SELECT', 'TEXTAREA'].includes(activeElement.tagName)
  ) {
    activeElement.blur();
  }

  document.querySelectorAll('button, a, input, select, textarea').forEach((el) => {
    if (el === document.activeElement) {
      el.blur();
    }
  });
}

export function blurAfterInteraction(event) {
  const target = event.target.closest('button, a');

  if (target) {
    setTimeout(() => {
      if (document.activeElement === target) {
        target.blur();
      }
    }, 0);
  }
}
